import React from 'react';
import { useTranslation } from 'react-i18next';
import { useApp } from '../../context/AppContext';
import DocumentItem from './DocumentItem';
import ProgressBar from './ProgressBar';

const EnhancedDocumentTracker = () => {
  const { t } = useTranslation();
  const { documents } = useApp();

  const documentList = [
    { id: 'passport', key: 'documents.checklistItems.0' },
    { id: 'visa', key: 'documents.checklistItems.1' },
    { id: 'residencePermit', key: 'documents.checklistItems.2' },
    { id: 'birthCertificate', key: 'documents.checklistItems.3' },
    { id: 'marriageCertificate', key: 'documents.checklistItems.4' },
    { id: 'proofOfResidence', key: 'documents.checklistItems.5' },
    { id: 'medicalRecords', key: 'documents.checklistItems.6' }
  ];

  const completedCount = documentList.filter(doc => documents[doc.id]?.checked).length;
  const totalCount = documentList.length;

  return (
    <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-sm">
      {/* Header with progress */}
      <div className="p-6 border-b border-gray-200 dark:border-gray-700">
        <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
          {t('documents.checklistTitle')}
        </h3>
        <ProgressBar completed={completedCount} total={totalCount} />
      </div>

      {/* Document items */}
      <div className="divide-y divide-gray-100 dark:divide-gray-700">
        {documentList.map((doc) => (
          <DocumentItem 
            key={doc.id} 
            documentId={doc.id}
            labelKey={doc.key}
          />
        ))}
      </div>
    </div>
  );
};

export default EnhancedDocumentTracker;
